/* ============
 * AccountingProvider Transformer
 * ============
 *
 * The transformer for the accountingProvider.
 */

import Transformer from './transformer';

export default class AccountingProviderTransformer extends Transformer {
  static fetch(accountingProvider) {
    return {
      id: accountingProvider.id,
      name: accountingProvider.name,
      slug: accountingProvider.slug,
    };
  }

  static send(accountingProvider) {
    return {
      id: accountingProvider.id,
      name: accountingProvider.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/accountingProvider.js